import { DATE_FORMAT, TIME_FORMAT, TIME_FORMAT_SECONDS } from "@constants";
import { i18n } from "@translations/i18n";
import { format } from "date-fns";

export const formatDateTime = (dateTime: string) => {
    const dateFormat = new Date(dateTime);
    const date = format(dateFormat, DATE_FORMAT);
    const time = format(dateFormat, TIME_FORMAT);

    return i18n.t("glossary:dateFormat", { DATE: date, TIME: time });
};


export const formatDateTimeSeconds = (dateTime: string) => {
    const correctedDateTime = dateTime.replace(" ", "T");
    const dateFormat = new Date(correctedDateTime);
    
    const date = format(dateFormat, DATE_FORMAT);
    const time = format(dateFormat, TIME_FORMAT_SECONDS);

    return i18n.t("glossary:dateFormat", { DATE: date, TIME: time });
};